import { withInstall } from '@chenms-zj/utils/with-install'
import _Cascader from './src/cascaders.vue'

export const Cascader = withInstall(_Cascader)
export default Cascader

export * from './src/cascaders'

// 这里添加的类型，可以在模板中被解析
declare module 'vue' {
  // 我们的接口可以自动合并
  export interface GlobalComponents {
    'cms-cascaders': typeof Cascader
  }
}
